module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/categories/childcare-fcf3bd436af2c340539aaea5b5265b4f.png";